import React from "react";
import store from "../../../redux/store";
import { addNotification as _addNotification, removeNotification as _removeNotification } from "../../../redux/slices/notificationsSlice";
import Loader from "@adeccoux/tag-ds/loader";
import { NOTIFICATION_DEFAULT_TIMER } from "../../../constants";

export interface INotificationitem {
  type: INotificationType;
  content: JSX.Element | string;
  richText?: boolean;
  timer?: number;
  id?: string;
  showTimer?: boolean; // To display pending time of the notification
  isPermanent?: boolean;
  onClick?: any;
  textLink?: string;
  title?: string;
  [others: string]: any;
}

export type INotificationType = "success" | "error" | "info" | "warning" | "loading";

export const addNotification = (notObct: INotificationitem) => {
  addNotificationBanner(notObct);
};

const addNotificationBanner = (notObct: INotificationitem) => {
  if (store) {
    if (notObct.isPermanent) {
      store.dispatch(_addNotification(notObct));
    } else if (!notObct.timer) {
      store.dispatch(_addNotification({ ...notObct, timer: NOTIFICATION_DEFAULT_TIMER }));
    } else {
      store.dispatch(_addNotification(notObct));
    }
  }
};

export const removeNotification = (notId: string | undefined) => {
  if (store && notId) store.dispatch(_removeNotification(notId));
};

export const getIcon = (type: string) => {
  switch (type) {
    case "success":
      return (
        <span className="material-icons" style={{ color: "var(--full-palette-semantic-success-400" }}>
          check_circle
        </span>
      );
    case "error":
      return (
        <span className="material-icons" style={{ color: "var(--full-palette-semantic-error-400" }}>
          cancel
        </span>
      );
    case "warning":
      return (
        <span className="material-icons" style={{ color: "var(--full-palette-semantic-warning-400" }}>
          warning
        </span>
      );

    case "loading":
      return <Loader spinner />;

    case "info":
    default:
      return <span className="material-icons">info</span>;
  }
};
